<template>
    <div
        class="page-class"
        :class="{
            farmer: userType == 'farmer',
            subdist: userType == 'subdist',
            dist: userType == 'dist',
            sale: userType == 'sale'
        }"
    >
        <div class="page-wrapper">
            <div class="page-content" v-if="isAccountLoaded">
                <nav-bar
                    :pageName="navbarName"
                    :userType="userType"
                    :isShowBack="true"
                    :isShowCurveBottom="true" 
                    @clickBack="clickBack"
                ></nav-bar>
                <div class="edit-profile-content">
                    <div class="editprofile-headline theme-txt">
                        {{ lbl.edit_profile.headline }}
                    </div>
                    <div id="editprofile_info" v-if="isLoaded">
                        <TextInput
                            addClass="ep-input"
                            :errorInfo="errorInfo[0]"
                            inputId="editprofile_firstname"
                            :inputLbl="lbl.edit_profile.name"
                            :inputMaxLength="60"
                            :isShowError="true"
                            :isSubmitted="isSubmitted"
                            :isTextOnly="true"
                            :isHideLabel="true"
                            v-model="name"
                        />
                        <TextInput
                            addClass="ep-input"
                            :errorInfo="errorInfo[1]"
                            inputId="editprofile_lastname"
                            :inputLbl="lbl.edit_profile.lastname"
                            :inputMaxLength="60"
                            :isShowError="true"
                            :isSubmitted="isSubmitted"
                            :isTextOnly="true"
                            :isHideLabel="true"
                            v-model="lastname"
                        />
                        <Email
                            addClass="ep-input"
                            :errorInfo="errorInfo[2]"
                            inputId="editprofile_email"
                            :inputLbl="lbl.edit_profile.email"
                            :isShowError="true"
                            :isHideLabel="true"
                            :isSubmitted="isSubmitted"
                            v-model="email"
                        />
                        <ContactNumber
                            addClass="ep-input"
                            addInputClass="disabled-txt"
                            :blockAutoComplete="true"
                            delimeter="-"
                            :errorInfo="errorInfo[3]"
                            inputId="editprofile_contact_number"
                            :inputLbl="lbl.edit_profile.contact_number"
                            :isReadOnly="true"
                            :isHideLabel="true"
                            v-model="contact_number"
                        />
                        <BirthDateInput
                            :errorInfo="errorInfo[4]"
                            :inputLbl="lbl.edit_profile.birthdate"
                            :isShowError="true"
                            :isSubmitted="isSubmitted"
                            :isDisabled="true"
                            v-model="birthdate"
                            @onDateChange="onDateChange($event)"
                        />
                        <ShopInput
                            class="mt-3"
                            ref="shop_info"
                            :lbl="lbl.edit_profile"
                            :errorInfo="errorInfo[5]"
                            :isShowError="true"
                            :isSubmitted="isSubmitted"
                            :shopInfo="shopInfo"
                            :modalController="modalController"
                        />
                    </div>
                    <div class="editprofile-remark">
                        {{ lbl.edit_profile.contact_number_remark_1 }}
                    </div>
                    <div class="editprofile-remark">
                        {{ lbl.edit_profile.contact_number_remark_2 }}
                    </div>
                </div>
                <!-- <edit-profile-livestock
                    :lbl="lbl.edit_profile"
                    :profileAnimalBreedController="profileAnimalBreedController"
                    :modalController="modalController"
                    v-if="userType == 'farmer' && isProfileAnimalConfigLoaded"
                ></edit-profile-livestock> -->
                <div class="edit-profile-content-bottom">
                    <div id="ep_edit_profile" class="btn-wrapper">
                        <div class="btn-txt" @click="clickEditProfile">
                            {{ lbl.edit_profile.edit_profile_btn }}
                        </div>
                    </div>
                </div>
            </div>

            <modal-master
                :controller="modalController"
                :theme="userType"
            ></modal-master>

            <div class="page-bg"></div>
            <!-- <cookie-consent-bar></cookie-consent-bar> -->
        </div>
    </div>
</template>
<script>
//helper
import Account from "@/helper/AccountHelper.js";
import DatetimeHelper from "@/helper/DatetimeHelper.js";
import FormHelper from "@/helper/FormHelper.js";
import Util from "@/helper/Utility.js";
import { TrackingService } from "@/helper/TrackingHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
// error
import { ErrorHandler } from "@/core/ErrorApi/ErrorHandler.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import NavBar from "@/components/Layout/NavBar/NavBar.vue";
// import EditProfileLivestock from "@/module/Profile/component/EditProfileLivestock.vue";
// import CookieConsentBar from '@/components/Layout/CookieConsentBar/CookieConsentBar.vue';
// input components
import BirthDateInput from "@/components/Input/BirthDateInput.vue";
import ContactNumber from "@/components/Input/ContactNumber.vue";
import Email from "@/components/Input/Email.vue";
import ShopInput from "@/components/Share/ShopInput.vue";
import TextInput from "@/components/Input/Text.vue";
//service
import BzbsProfile from "@/core/Account/service/BzbsProfile.js";
//controller
import ProfileAnimalBreedController from "../controller/ProfileAnimalBreedController.js";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import { ModalController } from "@/components/Modal/Controller/ModalController.js";
import { AlertModalController } from "@/components/Modal/Controller/AlertModalController.js";
import { LoadingModalController } from "@/components/Modal/Controller/LoadingModalController.js";
import { TermsModalController } from "@/components/Modal/Controller/TermsModalController.js";
export default {
    name: "edit-profile",
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    components: {
        NavBar,
        // EditProfileLivestock,
        BirthDateInput,
        ContactNumber,
        Email,
        ShopInput,
        TextInput,
        ModalMaster,
        // CookieConsentBar
    },
    computed: {
        userType: function() {
            return this.$store.state.userType;
        }
    },
    data: function() {
        return {
            isLoaded: false,
            isLoading: false,
            navbarName: "",
            //form
            isSubmitted: false,
            name: "",
            lastname: "",
            email: "",
            contact_number: "",
            birthdate: null,
            birthdateTimestamp: "",
            shopInfo: null,
            isValid: false,

            errorHandler: null,
            errorInfo: [],

            isProfileAnimalConfigLoaded: false,
            profileAnimalBreedController: new ProfileAnimalBreedController(),
            //modal
            modalController: new ModalController(),
            alertModal: new AlertModalController(),
            loadingModal: new LoadingModalController(),
            termsModal: new TermsModalController(),

            trackingService: new TrackingService(this),
            trackingScreenName: 'editprofile',
            trackingEventCategory: 'editprofile_page',
        };
    },
    created: function() {
        this.profileAnimalBreedController.setLbl(this.lbl.edit_profile);
        // modal
        this.modalController.setAlertModal(this.alertModal);
        this.modalController.setLoadingModal(this.loadingModal);
        this.modalController.setTermsModal(this.termsModal);
        // form setting
        this.errorInfo = FormHelper.genErrorInfo(6);
        // error handler
        this.errorHandler = new ErrorHandler();
        this.errorHandler.setAlertModal(this.alertModal);

        this.trackingService.screenName(this.trackingScreenName);
    },
    mounted: function() {
        this.navbarName = this.lbl.edit_profile.navname;
    },
    methods: {
        // event
        clickBack: function() {
            this.$router.back();
            this.trackingService.event(this.trackingEventCategory, 'click_back', null, null);
        },
        clickEditProfile: function() {
            this.isSubmitted = true;
            this.validator();

            this.trackingService.event(this.trackingEventCategory, 'click_update', null, null);
        },
        onDateChange: function(selectedBirthdate) {
            if (!selectedBirthdate) return;

            this.birthdateTimestamp = selectedBirthdate.timestamp;
        },
        // initial
        accountInitiated: function() {
            this.name = this.profile.strFirstName;
            this.lastname = this.profile.strLastName;
            this.email = this.profile.strEmail;
            this.contact_number = this.profile.strContactNumber;

            let checkDate = this.profile.strBirthDate.toString();
            if (checkDate.match(/^-{0,1}[0-9]+$/)) {
                this.birthdate = DatetimeHelper.convertTimeStampUnixToDate(this.profile.strBirthDate);
            }

            const isHaveExtend = !Util.isEmptyObject(this.profileExtendJson);
            if (isHaveExtend) {
                if (this.profileExtendJson.livestock
                    && this.profileExtendJson.livestock.data) {
                    this.initialCallback();
                    //this.profileAnimalBreedController.getProfileLivestock(this.profileExtendJson.livestock.data);
                }
                console.log("this.profileExtendJson", this.profileExtendJson);
                
                if (this.profileExtendJson.shop) {
                    this.shopInfo = {
                        Province: this.profileExtendJson.shop.province,
                        ShopName: this.profileExtendJson.shop.shopName,
                    };
                    // this.shopInfo = this.profileExtendJson.shop;
                }
            }

            this.isLoaded = true;
        },
        initialCallback: function() {
            this.profileAnimalBreedController.cbLoaded.onCallback(() => {
                this.isProfileAnimalConfigLoaded = true;
            });

            this.profileAnimalBreedController.cbError.onCallback(err => {
                this.errorResponse(err, this.errorHandler);
            });
        },
        // method
        editProfile: function() {
            const token = this.getToken();
            const shopInfo = this.$refs["shop_info"].getShopInfo();
            
            let params = {
                strFirstName: this.name,
                strLastName: this.lastname,
                strEmail: this.email,
                strBirthDate: this.birthdateTimestamp
            };
            let extendShop = {
                province: shopInfo.Province ? shopInfo.Province : shopInfo.province,
                shopName: shopInfo.ShopName ? shopInfo.ShopName : shopInfo.shopName,
                shopId: shopInfo.shopId
            }

            let extend = {
                livestock: {data: []},
                shop: extendShop
            };

            // if (this.userType == "farmer")
            //     extend.livestock = {data: []};

            this.showLoading();
            const strExtensionJson = JSON.stringify(extend);
            BzbsProfile.updateProfile(token, params, null, strExtensionJson)
                .then(() => {
                    return Account.apiGetProfile();
                })
                .then(() => {
                    this.hideLoading();
                    this.showAlert(
                        this.lbl.edit_profile.alert_edit_success_headline,
                        this.lbl.edit_profile.alert_edit_success_msg,
                        this.lbl.edit_profile.alert_btn,
                        () => {
                            this.$router.back();
                        }
                    );
                })
                .catch(err => {
                    this.hideLoading();
                    this.errorResponse(err, this.errorHandler);
                });
        },
        // validate
        validator: function() {
            const isValid = FormHelper.validate(this.errorInfo);
            const header_lbl = this.lbl.edit_profile.alert_headline;
            if (!isValid) {
                this.showAlert(
                    header_lbl,
                    this.lbl.edit_profile.fields_required,
                    this.lbl.edit_profile.alert_btn
                );
                return;
            }
            // console.log("livestock", livestock);
            // if (this.userType == "farmer" && !livestock.isValid) {
            //     this.showAlert(
            //         this.lbl.edit_profile.alert_headline,
            //         livestock.errorMsg,
            //         this.lbl.edit_profile.alert_btn
            //     );
            //     return;
            // }

            this.editProfile();
        },
        showAlert: function(title, msg, btn, callback) {
            this.modalController.alertModal
                .clearText()
                .setTitle(title)
                .setMsg(msg)
                .setBtnOk(btn)
                .setTag("edit-profile")
                .show();

            this.modalController.alertModal.onClickOk(callback);
        },
        showLoading: function() {
            if (this.isLoading) return true;

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function() {
            this.isLoading = false;
            this.loadingModal.hide();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.edit-profile-content-bottom {  
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 16px 20px;
    background: #fff;
    /* effect-campaign */
    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.15);
}
.edit-profile-content {
    width: 100%;
    padding: 0 20px 40px;
    margin-top: 32px;
    margin-bottom: 90px;

    @media (max-width: $max-width-mini-mobile) {
        padding: 0 20px;
    }

    #editprofile_info {
        .ep-input {
            @include baseProfileInput; 

            &:nth-last-child(1) {
                margin-bottom: 12px;
            }

            .input-wrapper {
                input {
                    height: 50px;
                    // padding-left: 115px; 
                    border: 1px solid #C4C4C4;
                    font-size: 24px;

                    @media (max-width: $max-width-mini-mobile) {
                        padding-left: 100px;
                        font-size: 1.4rem;
                    }
                }

                .input-lbl {
                    color: $text-gray;
                    font-size: 1.45rem;

                    @media (max-width: $max-width-mini-mobile) {
                        font-size: 1.4rem;
                    }
                }
            }
        }
    }

    .editprofile-remark {
        width: 100%;
        //font
        color: #333333;
        font-size: 1.3rem;
        text-align: center;
        line-height: 1.1;

        &:nth-last-child(1) {
            margin-bottom: 45px;

            @media (max-width: $max-width-mini-mobile) {
                margin-bottom: 40px;
            }
        }
    }

    #ep_edit_profile {
        margin-top: 16px;
        margin-bottom: 16px;
    }
}
</style>
<style lang="scss">
@import "@/style/base/common.scss";
@import "@/style/base/common.scss";
#editprofile_info {
    width: 100%;

    .ep-input {
        @include baseRegisterInput;
        margin-bottom: 16px;
    }
}

.editprofile-headline {
    @extend %base-headline;
    margin-bottom: 16px;
    font-size: 28px;
    text-align: left;
}

.editprofile-body {
    padding: 0 28px;

    @media (max-width: $max-width-mini-mobile) {
        padding: 0 20px;
    }
}
</style>
